import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type Props = {
  hasDownload?: boolean;
  hasOptions?: boolean;
  isAdminView?: boolean;
};

const DocumentsHeader: FC<Props> = ({
  hasDownload = true,
  hasOptions = true,
  isAdminView = false,
}) => {
  const { t } = useTranslate();

  return (
    <div className="nk-files-head">
      <div className="nk-file-item">
        <div className="nk-file-info">
          <span> {t('Name')}</span>
        </div>
        <div className="nk-file-members">
          <span> {t('Date')}</span>
        </div>
        {hasDownload && (
          <div className="nk-file-meta">
            <span> {t('Link')}</span>
          </div>
        )}
        {hasOptions && isAdminView && <div className="nk-file-meta" />}
      </div>
    </div>
  );
};

export default DocumentsHeader;
